import { render, staticRenderFns } from "./NavigationDropdown.vue?vue&type=template&id=04180665&scoped=true&"
import script from "./NavigationDropdown.vue?vue&type=script&lang=ts&"
export * from "./NavigationDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationDropdown.vue?vue&type=style&index=0&id=04180665&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04180665",
  null
  
)

export default component.exports